import React from 'react';
import { Field } from 'react-final-form';

import FormInput from 'Shared/components/FormComponents/FormInput';
import { required, useValidator, validEmailRequired } from 'Shared/utils/formValidations';
import CsrfInput from 'Dashboard/components/CsrfInput/CsrfInput';
import { createFormField } from 'Shared/utils/createFormField';
import PasswordField from 'Dashboard/components/PasswordField/PasswordField';

import GoogleButton from './GoogleButton/GoogleButton';
import Office365Button from './Office365Button/Office365Button';

const FormPassword = createFormField(PasswordField);

type Props = {
  forceToDesktop: boolean;
  cannotSignIntoGoogle: boolean;
  includeNameField: boolean;
};

function FormFields({ forceToDesktop, cannotSignIntoGoogle, includeNameField }: Props) {
  const emailRequired = useValidator(validEmailRequired, 'Invalid Email');

  return (
    <div>
      {!forceToDesktop && (
        <>
          {!cannotSignIntoGoogle && (
            <div className="d-flex justify-content-around mt-4 mb-3">
              <GoogleButton />
              <Office365Button />
            </div>
          )}
          {cannotSignIntoGoogle && (
            <div className="d-flex justify-content-center mt-4 mb-3">
              <Office365Button />
            </div>
          )}
          <div className="create-account-form-area-description d-flex align-items-center justify-content-center w-100">
            <hr className="w-100 mr-3" />
            or
            <hr className="w-100 ml-3" />
          </div>
          <div className="mt-3 mb-2">Sign up with email</div>
        </>
      )}
      <CsrfInput />
      {includeNameField && (
        <div className="mb-3">
          <Field
            name="user[name]"
            placeholder="Name"
            validate={required}
            label="Name"
            className="mt-3"
            component={FormInput}
            labelMuted
          />
        </div>
      )}
      <Field
        name="user[email]"
        placeholder="Email"
        validate={emailRequired}
        label="Work Email"
        className="mt-3"
        component={FormInput}
        labelMuted
      />
      <div className="mt-3">
        <Field
          name="user[password]"
          placeholder="Password"
          validate={required}
          label="Password"
          component={FormPassword}
          labelMuted
        />
      </div>
    </div>
  );
}

export default FormFields;
